import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { m } from 'framer-motion';
import { dialogHeightMinusHeader } from '~/shared/components/Overlay';
import { indicatePending } from '~/shared/utils/styled';
import { breakpoints } from '~/theme';

export const StyledReserveContainer = styled.div(({ theme }) => ({
    minWidth: '80vw',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spaces[4],

    [breakpoints.md]: {
        minWidth: 0,
        width: 'max(800px, 100%)',
        maxHeight: dialogHeightMinusHeader,
        // overflowY: 'scroll',
    },
}));

export const StyledReserveSection = styled.section<{ hasBorder?: boolean }>(
    ({ theme: { borders }, hasBorder = true }) => ({
        // padding: `0 ${getClampFullRange(spacesRaw[3], spacesRaw[6])}`,

        '& + &': {
            borderTop: hasBorder ? borders.border : '',
        },
    })
);

export const StyledPendingIndicator = styled.div<{ isFetching: boolean }>(
    ifProp('isFetching', {
        ...indicatePending,
    })
);

export const StyledReserveSectionMotion = m(StyledReserveSection);
